const initialState = {
  customizationData: {}
};

const customization = (state: any = initialState, action: any) => {
  switch (action.type) {
    case 'RECEIVE_CUSTOMIZATION':
      return {
        ...state,
        customizationData: action.customizationData
      };
    case 'CLEAN_CUSTOMIZATION':
      return {
        ...state,
        customizationData: {}
      };
    default:
      return state;
  }
};

export default customization;
